import { createContext, useContext, useState } from 'react';

const GlobalContext = createContext({});
export const GlobalContextProvider = GlobalContext.Provider;

export const useGlobalState = () => {
  return useContext(GlobalContext);
};

export default function GlobalState({ initialState = {}, children }) {
  const [user, setUser] = useState(initialState?.user);
  const [media, setMedia] = useState(initialState?.media);
  const [loading, setLoading] = useState(!!initialState?.loading);

  const toggleLoading = () => {
    setLoading(loading => !loading);
  };

  const selectMedia = (media) => {
    setMedia(media);
    localStorage.setItem('media_id', media.id);
  }

  return (
    <GlobalContext.Provider value={{
      user,
      setUser,
      media,
      setMedia: selectMedia,
      loading,
      setLoading,
      toggleLoading,
    }}>
      {children}
    </GlobalContext.Provider>
  );
}
